import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { AppService } from '../services/app.service';
import { environment } from '@environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private appService: AppService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(environment.endpointI18nCDN.url)) {
      return next.handle(request)
    }
    
    let accessToken = this.appService.currentUser.accessToken

    if (!accessToken) {
      accessToken = window.location.search.split("accessToken=")[1]
    }

    request = request.clone({
      setHeaders: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type':  'application/json'
      }
    });
    return next.handle(request)
  }
}
